import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { LoginButton } from './LoginButton';

interface AuthGuardProps {
  children?: React.ReactNode;
}

export function AuthGuard({ children }: Readonly<AuthGuardProps>) {
  const { isAuthenticated, isLoading } = useKindeAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <p
          role="status"
          aria-live="polite"
          className="flex items-center gap-2 text-muted-foreground"
        >
          <Loader2 className="h-5 w-5 animate-spin" />
          {t('auth.loading')}
        </p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col items-center gap-4 py-12">
        <LoginButton />
      </div>
    );
  }

  return <>{children}</>;
}
